// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__11dC2","header":"ReportDetails_header__3qVtF","title":"ReportDetails_title__rv7Uy","left":"ReportDetails_left__-GGqU"};